import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
import { SelectToggleButton } from "../../../../../../../../../SelectToggleButton/modules/EcommContent/components/SelectToggleButton/SelectToggleButton.js";
import { TileLayout } from "../../../../../../../../../TileLayout/modules/EcommContent/components/TileLayout/TileLayout.js";
import { CartDiscountType } from "../../../../../../../../../../../../hooks/useCartDiscountsQuery/hooks/useCartDiscountsQuery/types.js";
const getLabelKeys = (discountType, discountAmount, locale, currency) => {
  switch (discountType) {
    case CartDiscountType.PERCENT:
      return {
        titleKey: "products.quantityDiscount.percent.title",
        subtitleKey: "products.quantityDiscount.percent.subtitle",
        discountValue: discountAmount
      };
    case CartDiscountType.AMOUNT:
      const price = formatPrice({
        locale,
        currency,
        value: discountAmount,
        isCentAmount: false,
        fixedDecimals: false
      });
      return {
        titleKey: "products.quantityDiscount.amount.title",
        subtitleKey: "products.quantityDiscount.amount.subtitle",
        discountValue: price
      };
  }
};
const CartQuantityDiscountSelectBox = ({ item, isSelected, onClick, className }) => {
  const { getFormattedLabel, locale, currency } = useIntl();
  const { minimumQuantity, discount } = item;
  const { amount } = discount;
  const { titleKey, subtitleKey, discountValue } = getLabelKeys(
    discount.type,
    amount,
    locale,
    currency
  );
  const title = getFormattedLabel(titleKey, { labelData: { amount: discountValue } });
  const subtitle = getFormattedLabel(subtitleKey, { labelData: { minimumQuantity } });
  return /* @__PURE__ */ React.createElement(
    SelectToggleButton,
    {
      value: item,
      isSelected,
      onClick,
      className
    },
    /* @__PURE__ */ React.createElement(TileLayout, { title, subtitle })
  );
};
export {
  CartQuantityDiscountSelectBox
};
//# sourceMappingURL=CartQuantityDiscountSelectBox.js.map
